export default __webpack_public_path__ + "static/media/carfest-md.ae0cdf39.png";